var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"back"},[_c('div',{staticClass:"dialogbox",style:({
    width: `${_vm.width}px`,
    maxHeight: _vm.height ? `${_vm.height}px` : 'fit-content'
  })},[_c('div',{staticClass:"headerBox"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('button',{staticClass:"closeBtn",on:{"click":function($event){return _vm.$emit('close')}}},[_c('iconClose',{attrs:{"width":25,"height":25,"color":"#FFFFFF","backgroundColor":"none"}})],1)]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }